// extracted by mini-css-extract-plugin
export var header = "Header-module--header--pPkNJ";
export var logo = "Header-module--logo--x9vAO";